import React, { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
    settheInternalSubQuestionActions,
    settheInternalDepartmentsctions,
    settheCreateInternalTickets,
    settheTicketSuccesspopuos,
    settheTicketViewIds,
    getTheUDSQuestionsData,
    setRegionActions,
    setGeoLoactionStateAction,
    settheclientloneticketactions,
    setZoneActions,
    setUserActions
} from "../../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { toast } from "react-toastify";
import { PresentUrl } from "../../../../text/apidata";
import { store } from "../../../../Redux/Store";
import axios from "axios";
import TicketCreation from "../../../../Assets/AppComponent/Group 427320077.svg"
import Userim from "../../../../Assets/AppComponent/Layer_1 (2).svg";
import CloseIcons from "../../../../Assets/AppComponent/Group 442 (1).svg";

import galleryImg from "../../../../Assets/AppComponent/Union (25).svg";
import { useNavigate } from "react-router-dom";
import thumbsup from "../../../../Assets/AppComponent/plastic-hand-with-thumb-up 1 (1).svg";
import ticketimg from "../../../../Assets/AppComponent/Union (17).svg";
import closepopup from "../../../../Assets/AppComponent/Group 442 (1).svg";
import galleyimg from "../../../../Assets/AppComponent/Vector (20).svg"

import PDFIMAGE from "../../../../Assets/AppComponent/Rectangle.png"
import excelimg from "../../../../Assets/AppComponent/download.png"
import gallimages from "../../../../Assets/AppComponent/Vector (20).svg"
import useDebouncedEffect from 'use-debounced-effect';
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import DropdownIndicator from "../../../AppComponent/InputFields/DropdownIndicator";





const TicketraiseforInternal = (props) => {
    const { show, setShow, getthesearch, currentPage,

        from_date,
        to_date,
        status,
        priority,
        stateids,
        region,
        zone,
        client,

    } = props;
    const state = useSelector((state) => state);
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState({});
const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current.click(); // Trigger the hidden file input
  };

const [creating, setCreating] = useState(false);
const [User_options  , setUser_options] = useState([])

const [User_selected , setUser_selected] = useState(null)

    const LoaderData = useSelector((state) => state.Loader.isLoading);

    const initialStateSearch = {
        categorySearch: "",
        usersearh: "",
        departmentseach: "",
        stateSearch: '',
            Statefiltersearch: "",
    regionalsearch: "",
    clientSearchs:"",
    zoneSearch:"",
    User_searched:""


    };
    const [SearchedVal, setSearched] = useState(initialStateSearch);

    const initialDebouanceSearch = {
        categorySearch: "",
        usersearh: "",
        departmentseach: "",
        stateSearch: '',
                    Statefiltersearch: "",
    regionalsearch: "",
    clientSearchs:"",
        zoneSearch:"",
        User_searched:""

    };
    
    const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);


    const createnewuser = {
        remarks: "",
        priority: "",
        client_subcategory: true,
        internal_category_id: "",
        department_id: "",
        document: [],
        category: "",
        created_behalf:"",
        actual_creater:""
    };

    const [data, setData] = useState(createnewuser);
    const [Priorityvalues, setPriorityvalues] = useState([])
    const [departmentValue, setDepartmentvalues] = useState([]);
    const [departmentoptions, setdepartmentoptions] = useState([]);

     const [datas, setDatas] = useState({
    state: "",
    region: "",
            client_id:null,
            zone:""
  });

  const [StateVal, setStateVal] = useState([]);
  const [StateOptions, setStateOptions] = useState([]);

  const [RegionOption, setRegionOptions] = useState([]);
  const [RegionVal, setRegionVal] = useState([]);

  const [ZoneOptions, setZoneOptions] = useState([]);
  const [ZoneValues , setZoneValues]= useState([])

    const [ClientOptions , setClientoptions] = useState([])
const [ClientValues , setClientValues] = useState([])

    const dispatch = useDispatch();

    const priorityoptions = [
        {
            value: "0",
            label: "Low"
        },
        {
            value: "1",
            label: "Medium"

        },
        {
            value: "2",
            label: "High"

        }
    ];

    const [Categorydata, setcategoryData] = useState([]);
    const [categoryvalue, setcategoryvalues] = useState([]);

    const [PresentUrls, setPresentUrls] = useState([]);
    const [presenturlInUrl, seturlandfile] = useState([]);
    const [croppedFileState, setcroppedFilestatet] = useState([]);
    const [documentnotuploads, setdosumentuploads] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const [isDragging, setIsDragging] = useState(false);

    const handleDragEnter = () => setIsDragging(true);
    const handleDragLeave = () => setIsDragging(false);

    const [thankcontent, setthankcontent] = useState(true);
    const [thanksContent, setThankthanksContent] = useState(true);
    const [categoryvaluese, setCategoryvaluesdep] = useState([])
    const [categoryption, setcategoryOptions] = useState([])
    const Navigate = useNavigate()



      const HandleTheStateChanges = (selected) => {
    setStateVal(selected);
    setRegionVal([]);
    setDatas({
      ...datas,
      state: selected?.value,
      region: "",
            client_id:null,
            zone:""
    });
    setZoneValues([])
        setClientValues([])

  };
  const HandleTheZoneChanges =(selected)=>{
    setZoneValues(selected);
    setDatas({
        ...datas,
         zone:selected.value
    })
  }
  
  const HandleTheRegionChanges = (selected) => {
    setRegionVal(selected);
          setClientValues([])
    setZoneValues([])


    setDatas({
      ...datas,
      region: selected?.value,
            client_id:null,
            zone:""
    });
  };


  const HandletheclientValues =(selected)=>{
    setClientValues(selected)

    setDatas({
      ...datas,
      client_id: selected?.value,
    });
  }


const handletheUser_selected =(selected)=>{
if(selected){
  setUser_selected(selected)
    setData({
      ...data,
      created_behalf: selected?.value,
      actual_creater:state?.SideBarFiles?.LoginIDs
    });
}
else {
  setUser_selected(null)
    setData({
      ...data,
      created_behalf: "",
      actual_creater:state?.SideBarFiles?.LoginIDs

    });
}
}
console.log(state?.SideBarFiles?.LoginIDs ,"state?.SideBarFiles?.LoginIDs");

    const HandleCategoryMuliti = (e) => {
        if (e != null) {
            setcategoryvalues(e);

            setData({
                ...data,
                internal_category_id: e.value
            })
        }
    }

    const handletheprioritychanges = (e) => {
        setPriorityvalues(e)
        setData({
            ...data,
            priority: e.value
        })
    }

    const HandletheDepartmentvalues = (e) => {
        setDepartmentvalues(e)
        setCategoryvaluesdep([])
        setcategoryvalues([])

        setData({
            ...data,
            department_id: e.value,
            category: "",
            internal_category_id: ""


        })
    }



    const HandletheCatgoryListed = (e) => {
        setCategoryvaluesdep(e);
        setcategoryvalues([])
        setData({
            ...data,
            category: e.value,
            internal_category_id: ""

        })
    }

    useEffect(() => {
         if(data.department_id !=""){
        const payload = {
            search: SearchedVal.stateSearch,
            page_size: 20,
            page: 1,
            department_id: data.department_id,
        };
        dispatch(getTheUDSQuestionsData(payload));
    }
    }, [SearchedVal.stateSearch, data.department_id]);

    useEffect(() => {
        if (data.department_id != "") {
            if (state.UDSQuetionsDatas.UDSCateQuestionsDatas != undefined) {
                let ObjectArrayFormager = [];
                let storethefirstindex = [];
                state.UDSQuetionsDatas.UDSCateQuestionsDatas != undefined && state.UDSQuetionsDatas.UDSCateQuestionsDatas != null && state.UDSQuetionsDatas.UDSCateQuestionsDatas.forEach((element) => {
                    ObjectArrayFormager.push({
                        value: element.id,
                        label: element.name,
                    });
                    if (state.UDSQuetionsDatas.UDSCateQuestionsDatas.length == 1) {
                        storethefirstindex.push({
                            value: element.id,
                            label: element.name,
                        })
                    }
                });
                if (state.UDSQuetionsDatas.UDSCateQuestionsDatas.length == 1) {

                setCategoryvaluesdep(storethefirstindex);
                setcategoryvalues([])                 
                setData({
                    ...data,
                    category: storethefirstindex[0]?.value,
                    internal_category_id: ""
        
                })
            }

                setcategoryOptions(ObjectArrayFormager);
            }
        }
        else {
                             setcategoryOptions([]);

        }
    }, [state.UDSQuetionsDatas.UDSCateQuestionsDatas, SearchedVal.stateSearch, data.department_id]);

  useEffect(() => {
    if(datas.state !="" &&
      datas.state != null &&
      datas.region !="" &&
      datas.region != null 
    ){ 
    const payload = {
      search: SearchedVal.clientSearchs,
      page_size: 20,
      page: 1,
      state: datas.state,
      region: datas.region,
      is_internal:true,
    };
    dispatch(settheclientloneticketactions(payload));
  }
  }, [SearchedVal.clientSearchs, datas.state, datas.region]);

    ///---user--manager-----------
  useEffect(() => {
    const payload = {
      search: SearchedVal.User_searched,
      page_size: 10,
      page: 1,
      white_collar: true,
         state: datas.state,
      region: datas.region,
    };
    dispatch(setUserActions(payload));
  }, [SearchedVal.User_searched, datas.region, datas.state]);



useEffect(() => {
    if (state.Usergetlists.UserList !== undefined) {
      let ObjectArrayFormager = [];
      state.Usergetlists.UserList.forEach((element) => {
        if (element?.id) {
        ObjectArrayFormager.push({
          value: element.id,
          label: `${element.first_name}${ element.email != null && element?.email != ""  ? ` (${element.email})` : ""}`,
        });
      }
      });

      setUser_options(ObjectArrayFormager);
    }
  }, [
    state.Usergetlists.UserList,
    SearchedVal.User_searched,
  ]);

  useEffect(() => {
    if (datas.state != null &&
      datas.region != null &&
       datas.state != "" &&
      datas.region != "" &&
      state.ClientTicketListedDatahold.ClientTicketholded !== undefined) {
      let ObjectArrayFormager = [];
      state.ClientTicketListedDatahold.ClientTicketholded.length > 0 &&
        state.ClientTicketListedDatahold.ClientTicketholded.forEach(
          (element) => {
            ObjectArrayFormager.push({
              value: element.id,
              label: element.client_name,
            });
          }
        );

      setClientoptions(ObjectArrayFormager);
    }
    else {
            setClientoptions([]);

    }
  }, [
    state.ClientTicketListedDatahold.ClientTicketholded,
    SearchedVal.clientSearchs,
       datas.state,
    datas.region,
  ]);


    useEffect(() => {
        if(data.category != ""){ 
        const payload = {
            search: SearchedVal.categorySearch,
            page_size: 20,
            page: 1,
            category: data.category
        };
        dispatch(settheInternalSubQuestionActions(payload));
    }
    }, [SearchedVal.categorySearch, data.category]);

    useEffect(() => {
   
        const payload = {
            search: SearchedVal.departmentseach,
            page_size: 20,
            page: 1,
        };
        dispatch(settheInternalDepartmentsctions(payload));
    
    }, [SearchedVal.departmentseach ]);




    useEffect(() => {
        if (
            
            state.InternalSubDepartmentsDatas.internalDepartmentDatas !== undefined) {
            let ObjectArrayFormager = [];
            state.InternalSubDepartmentsDatas.internalDepartmentDatas.length > 0 && state.InternalSubDepartmentsDatas.internalDepartmentDatas.forEach((element) => {
                ObjectArrayFormager.push({
                    value: element.id,
                    label: element.department_name,
                });

            });


            setdepartmentoptions(ObjectArrayFormager);

        }
        else {
                        setdepartmentoptions([]);

        }
    }, [state.InternalSubDepartmentsDatas.internalDepartmentDatas, SearchedVal.departmentseach]);



    useEffect(() => {
        if (data.department_id != "" && data.category != "") {
            if (state.InternalSubQuetionsDatas.internalQuestionsDatas !== undefined) {
                let ObjectArrayFormager = [];
                state.InternalSubQuetionsDatas.internalQuestionsDatas.forEach((element) => {
                    ObjectArrayFormager.push({
                        value: element.id,
                        label: element.name,
                    });

                });


                setcategoryData(ObjectArrayFormager);
            }
        }
        else {
                            setcategoryData([]);


        }
    }, [state.InternalSubQuetionsDatas.internalQuestionsDatas, SearchedVal.categorySearch, data.department_id]);

    useDebouncedEffect(
        () => {
            if (setSearchDebounance) {
                setSearched({
                    ...SearchedVal,
                    categorySearch: SearchDebounance.categorySearch,
                    departmentseach: SearchDebounance.departmentseach,
                    stateSearch: SearchDebounance.stateSearch,
                    usersearh:SearchDebounance.usersearh,
                              Statefiltersearch: SearchDebounance.Statefiltersearch,
          regionalsearch: SearchDebounance.regionalsearch,
                    clientSearchs: SearchDebounance.clientSearchs,

                    User_searched:SearchDebounance.User_searched

                });
    
            }
        },
        500,
        [SearchDebounance]
    );
    

      ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.Statefiltersearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.Statefiltersearch]);

  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });

      setStateOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.Statefiltersearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionalsearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: datas.state,
    };
    dispatch(setRegionActions(payloads));
  }, [datas.state, SearchedVal.regionalsearch]);

    //--------------_Zone---------------
  useEffect(() => {
 if(datas.state !="" &&
      datas.state != null &&
      datas.region !="" &&
      datas.region != null 
    ){ 
     const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: datas.region,
    };
    dispatch(setZoneActions(payloads));
}
  }, [datas.region ,datas.zone, SearchedVal.zoneSearch]);

    ///-------------Zone--------------
  useEffect(() => {
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setZoneOptions(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch,]);


  ///  ///----------------------REgion-----------
  useEffect(() => {
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });

      setRegionOptions(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionalsearch]);

    

  const HandletheStateSearch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      Statefiltersearch: e,
    });
  };
    const HandletheClientsSearch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      clientSearchs: e,
    });
  };

  const HandletheRegionSearch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionalsearch: e,
    });
  };
    const handleInputcategory = (e) => {
        setSearchDebounance({
            ...SearchDebounance,
                  categorySearch: e
        })
    }
    const handleInputDepartment = (e) => {
        setSearchDebounance({
            ...SearchDebounance,
                  departmentseach: e
        })
    }

    const handleUser_serached =(e)=>{
          setSearchDebounance({
            ...SearchDebounance,
                  User_searched: e
        }) 
    }

const HandletheZoneSearch =(e)=>{
        setSearchDebounance({
            ...SearchDebounance,
                  zoneSearch: e
        })
}

    useEffect(() => {
        if (uploadedFiles.length == 0) {
            setdosumentuploads(false);
        }
    }, [uploadedFiles]);

  
    const handleInputcategorySearc = (e) => {
        setSearchDebounance({
            ...SearchDebounance,
                  stateSearch: e
        })
    }


    const handleDrop = useCallback((event) => {
        event.preventDefault();

        const droppedFiles = Array.from(event.dataTransfer.files);
        const validFiles = droppedFiles.filter((file) => {
            const isPhotoOrVideo =
                file.type.startsWith("image/") || file.type.startsWith("video/");
            const isExcel =
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.ms-excel";
            const isPdf = file.type === "application/pdf";
            const isEmail = file.type === "message/rfc822"; // MIME type for email files
            const isUnder5MB = file.size <= 25 * 1024 * 1024; // 5 MB size limit
            if (!isUnder5MB) {
                toast.error(`${file.name} exceeds the 25 MB size limit.`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }

            // return (isPhotoOrVideo || isExcel || isPdf || isEmail) && isUnder5MB;
            return isUnder5MB
        });

        const invalidFiles = droppedFiles.filter((file) => {
            const isPhotoOrVideo =
                file.type.startsWith("image/") || file.type.startsWith("video/");
            const isExcel =
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.ms-excel";
            const isPdf = file.type === "application/pdf";
            const isEmail = file.type === "message/rfc822";
            const isUnder5MB = file.size <= 25 * 1024 * 1024;

            // Check if the file fails size validation
            if (!isUnder5MB) {
                toast.error(`${file.name} exceeds the 25 MB size limit.`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }

            // Check if the file fails type validation
            // if (!(isPhotoOrVideo || isExcel || isPdf || isEmail)) {
            //     toast.error(`${file.name} is not a valid file type.`, {
            //         position: "top-right",
            //         autoClose: 5000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: true,
            //     });
            // }

            // return !(isPhotoOrVideo || isExcel || isPdf || isEmail) || !isUnder5MB;
            return !isUnder5MB;
        });
        // Exit if no valid files
        if (validFiles.length === 0) {
            return;
        }

        validFiles.forEach((file) => {
            const reader = new FileReader();

            reader.onload = () => {
                const base64Url = reader.result;

                // console.log(base64Url, "odapisbase64Url");

                // setUploadedFiles((prevFiles) => [
                //     ...prevFiles,
                //     // { file, base64Url },
                //     {  base64Url },

                // ]);
                setUploadedFiles((prevFiles) => [...prevFiles, base64Url]);
            };

            reader.readAsDataURL(file);
        });

        if (validFiles.length > 0) {
            const newFiles = validFiles.map((file) => URL.createObjectURL(file));


            setUploadedFiles((prev) => [...prev, ...newFiles]);
            setdosumentuploads(true);
            setcroppedFilestatet((prev) => [...prev, ...validFiles]);


            const generateRandomNumber = () => {
                return Math.floor(Math.random() * 100000);
            };

            const createPresentData = (file) => {
                const randomNumber = generateRandomNumber();
                const formattedFilename = `ticketing_system/internal_ticket/${file.name}`; // Adjust the filename as needed
                return {
                    multiple_files: [
                        {
                            filename: formattedFilename,
                            file_type: file.type,
                        },
                    ],
                };
            };

            validFiles.forEach((fileOfsend) => {
                const presentData = createPresentData(fileOfsend);

                axios({
                    url: PresentUrl,
                    method: 'post',
                    data: presentData,
                    headers: {
                        Authorization:
                            "Bearer " + store.getState().users.UserData.session.token,
                    },
                })
                    .then((response) => {
                        // console.log('Files uploaded successfully:', response.data);
                        const uploadedFiles = response.data.data;

                        const newUrls = uploadedFiles.map(file => ({
                            url: file,
                            type: fileOfsend.type,
                            putfiles: fileOfsend

                        }));
                        setPresentUrls((prevUrls) => [...prevUrls, ...newUrls]);

                        const SendUrl = String(response.data.data).split("?")[0]; // Extract URL up to '?'

                        if (SendUrl) {
                            seturlandfile((prevUrls) => [...prevUrls, SendUrl]); // Add the URL to the array
                        }


                    }).catch((error) => {
                        console.error('Error uploading files:', error);
                    });
            });


            //   validFiles.forEach((file) => {
            //     const presentData = createPresentData(file);
            //     createPresntUrlMutation.mutate(
            //       { filepart: file, responsedatas: presentData },
            //       {
            //         onSuccess: (response) => {},
            //         onError: (error) => {},
            //       }
            //     );
            //   });
        }
    }, []);
    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        const validFiles = files.filter((file) => {
            const isPhotoOrVideo =
                file.type.startsWith("image/") || file.type.startsWith("video/");
            const isExcel =
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.ms-excel";
            const isPdf = file.type === "application/pdf";
            const isEmail = file.type === "message/rfc822"; // MIME type for email files
            const isUnder5MB = file.size <= 25 * 1024 * 1024; // 5 MB size limit

            if (!isUnder5MB) {
                toast.error(`${file.name} exceeds the 25 MB size limit.`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }


            // return (isPhotoOrVideo || isExcel || isPdf || isEmail) && isUnder5MB;
            return isUnder5MB;
        });

        const invalidFiles = files.filter((file) => {
            const isPhotoOrVideo =
                file.type.startsWith("image/") || file.type.startsWith("video/");
            const isExcel =
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.ms-excel";
            const isPdf = file.type === "application/pdf";
            const isEmail = file.type === "message/rfc822";
            const isUnder5MB = file.size <= 25 * 1024 * 1024;

            // Check if the file fails size validation
            if (!isUnder5MB) {
                toast.error(`${file.name} exceeds the 25 MB size limit.`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }

      
            return !isUnder5MB;
        });
        // Exit if no valid files
        if (validFiles.length === 0) {
            return;
        }

        const newFiles = validFiles.map((file) => URL.createObjectURL(file));
        setUploadedFiles((prev) => [...prev, ...newFiles]);
        setdosumentuploads(true);
        setcroppedFilestatet((prev) => [...prev, ...validFiles]);

        const generateRandomNumber = () => {
            return Math.floor(Math.random() * 100000);
        };
        const createPresentData = (file) => {
            const randomNumber = generateRandomNumber();
            const formattedFilename = `ticketing_system/internal_ticket/${file.name}`; // Adjust the filename as needed
            return {
                multiple_files: [
                    {
                        filename: formattedFilename,
                        file_type: file.type,

                        // file_type: file.type =="" ? "image/svg+xml": file.type,
                    },
                ],
            };
        };
    // setUploading(true);
    setProgress(0);


//     validFiles.forEach((fileOfsend) => {
//   const presentData = createPresentData(fileOfsend);

//   // mark file as uploading

//   axios({
//     url: PresentUrl,
//     method: "post",
//     data: presentData,
//     headers: {
//       Authorization:
//         "Bearer " + store.getState().users.UserData.session.token,
//     },
//     onUploadProgress: (progressEvent) => {
//           setUploading((prev) => ({ ...prev, [fileOfsend.name]: true }));

//       if (progressEvent.total) {
//         const percent = Math.round(
//           (progressEvent.loaded * 100) / progressEvent.total
//         );
//         // track progress per file
//         setProgress((prev) => ({
//           ...prev,
//           [fileOfsend.name]: percent,
//         }));
//       }
//     },
//   })
//     .then((response) => {
//       const uploadedFiles = response.data.data;

//       const newUrls = uploadedFiles.map((file) => ({
//         url: file,
//         type: fileOfsend.type,
//         putfiles: fileOfsend,
//       }));
//       setPresentUrls((prevUrls) => [...prevUrls, ...newUrls]);

//       const SendUrl = String(response.data.data).split("?")[0];
//       if (SendUrl) {
//         seturlandfile((prevUrls) => [...prevUrls, SendUrl]);
//       }
//     })
//     .catch((error) => {
//       console.error("Error uploading files:", error);
//     })
//    .finally(() => {
//   setProgress((prev) => ({ ...prev, [fileOfsend.name]: 100 })); // ensure full
//   setTimeout(() => {
//     setUploading((prev) => ({ ...prev, [fileOfsend.name]: false }));
//   }, 800); // let the user see it finish
// });

// });



const uploadFilesSequentially = async (validFiles) => {
  for (const fileOfsend of validFiles) {
    const presentData = createPresentData(fileOfsend);

    setUploading((prev) => ({ ...prev, [fileOfsend.name]: true }));

    try {
      const response = await axios({
        url: PresentUrl,
        method: "post",
        data: presentData,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress((prev) => ({
              ...prev,
              [fileOfsend.name]: percent,
            }));
          }
        },
      });

      const uploadedFiles = response.data.data;
      const newUrls = uploadedFiles.map((file) => ({
        url: file,
        type: fileOfsend.type,
        putfiles: fileOfsend,
      }));
      setPresentUrls((prevUrls) => [...prevUrls, ...newUrls]);

      const SendUrl = String(response.data.data).split("?")[0];
      if (SendUrl) {
        seturlandfile((prevUrls) => [...prevUrls, SendUrl]);
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    } finally {
      setProgress((prev) => ({ ...prev, [fileOfsend.name]: 100 }));
      await new Promise((resolve) => setTimeout(resolve, 800));
      setUploading((prev) => ({ ...prev, [fileOfsend.name]: false }));
    }
  }
};
uploadFilesSequentially(validFiles);

    };

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const removeFile = (index) => {
        setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
        setcroppedFilestatet((prev) => prev.filter((_, i) => i !== index));
        setPresentUrls((prev) => prev.filter((_, i) => i !== index));
        seturlandfile((prev) => prev.filter((_, i) => i !== index));
    };

    console.log(PresentUrls ,"PresentUrls",uploading);
    
    // const HandleClick = (e) => {

  
    //     const fetchUploadFiles = async () => {
    //         await Promise.all(PresentUrls.map(async (item, index) => {
    //             console.log(item, "item");

    //             try {
    //                 if (item != undefined && item != null) {

    //                     const response = await fetch(item.url, {
    //                         method: 'PUT',
    //                         headers: {
    //                             'Content-Type': item.type,
    //                             "x-amz-acl": "public-read"
    //                         },
    //                         body: item.putfiles,
    //                     });

    //                     if (!response.ok) {
    //                         throw new Error(`HTTP error! Status: ${response.status}`);
    //                     }

    //                     if (PresentUrls.length == index + 1) {
    //                         const payload = {
    //                             data: {
    //                                 remarks: data.remarks,
    //                                 priority: data.priority,
    //                                 client_subcategory: true,
    //                                 internal_category_id: data.internal_category_id,
    //                                 department_id: data.department_id,
    //                                 documents: presenturlInUrl,
    //                               state_id:datas.state,
    //                     region_id:datas.region,
    //                     client_id: datas.client_id ?datas.client_id : null,
    //                     zone_id:datas.zone ? datas.zone : null 


    //                             },
    //                             getpayloads: {
    //                                 search: "",
    //                                 currentPage: 1,
    //                                 page_size: 20,
    //                             }


    //                         }
    //                         dispatch(settheCreateInternalTickets(payload
    //                             // ,state.NeededdatasListed.RoutesDefinedof == 0 ?Navigate("/internaldashboard") : Navigate("/internalTicket")
    //                         ))
    //                     }

    //                 }
    //             } catch (error) {
    //                 console.error('Error uploading files:', error);
    //             }
    //         }));
    //     };


    //     if (data.department_id != "" &&
    //         data.internal_category_id != "" &&
    //         data.priority != ""
    //         &&
    //               datas.state !=""&&
    //   datas.region !=""
    //   &&
    //   datas.zone != ""

    //     ) {

    //         if (documentnotuploads == true) {
    //             fetchUploadFiles()
    //         }

    //         else {
    //             const payload = {
    //                 data: {
    //                     remarks: data.remarks,
    //                     priority: data.priority,
    //                     client_subcategory: true,
    //                     internal_category_id: data.internal_category_id,
    //                     department_id: data.department_id,
    //                     documents: [],
    //                     state_id:datas.state,
    //                     region_id:datas.region,
    //                     client_id: datas.client_id ?datas.client_id : null,
    //                     zone_id:datas.zone ? datas.zone : null 

    //                 },
    //                 getpayloads: {
    //                     from_date: from_date,
    //                     to_date: to_date,
    //                     range: true,
    //                     status: status,
    //                     priority: priority,
    //                     state: stateids,
    //                     region: region,
    //                     zone: zone,
    //                     client: client,
    //                     search: getthesearch,
    //                     currentPage: currentPage,
    //                     page_size: 20,
    //                 }


    //             }
    //             dispatch(settheCreateInternalTickets(payload,

    //                 // state.NeededdatasListed.RoutesDefinedof == 0 ?Navigate("/internaldashboard") : Navigate("/internalTicket")


    //             ))
    //         }
    //     }
    //     else {
    //         toast.info("Please Fill the Mandatory Fields");

    //     }

    // }
    console.log(data ,"data osudpoid ");
    
const HandleClick = async (e) => {
  e.preventDefault();
  setCreating(true); // disable button right away

const fetchUploadFiles = async () => {
  try {
    // wait for ALL uploads to finish
    await Promise.all(
      PresentUrls.map(async (item) => {
        if (item) {
          const response = await fetch(item.url, {
            method: "PUT",
            headers: {
              "Content-Type": item.type,
              "x-amz-acl": "public-read",
            },
            body: item.putfiles,
          });

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
        }
      })
    );

    // ⬇️ this runs only after all uploads succeed
    const payload = {
      data: {
        remarks: data.remarks,
        priority: data.priority,
        client_subcategory: true,
        internal_category_id: data.internal_category_id,
        department_id: data.department_id,
        documents: presenturlInUrl,
        state_id: datas.state,
        region_id: datas.region,
        client_id: datas.client_id ? datas.client_id : null,
        zone_id: datas.zone ? datas.zone : null,
        created_behalf: data?.created_behalf ?  data?.created_behalf : null,
        actual_creater: data?.actual_creater ?  data?.actual_creater : null,

      },
      getpayloads: {
        search: "",
        currentPage: 1,
        page_size: 20,
      },
    };

    dispatch(settheCreateInternalTickets(payload));
  } catch (error) {
    console.error("Error uploading files:", error);
  }
};


  try {
    if (
      data.department_id !== "" &&
      data.internal_category_id !== "" &&
      data.priority !== "" &&
      datas.state !== "" &&
      datas.region !== "" &&
      datas.zone !== ""
    ) {
      if (documentnotuploads === true) {
        await fetchUploadFiles();
      } else {
        const payload = {
          data: {
            remarks: data.remarks,
            priority: data.priority,
            client_subcategory: true,
            internal_category_id: data.internal_category_id,
            department_id: data.department_id,
            documents: [],
            state_id: datas.state,
            region_id: datas.region,
            client_id: datas.client_id ? datas.client_id : null,
            zone_id: datas.zone ? datas.zone : null,
                    created_behalf: data?.created_behalf ?  data?.created_behalf : null,
        actual_creater: data?.actual_creater ?  data?.actual_creater : null,

          },
          getpayloads: {
            from_date: from_date,
            to_date: to_date,
            range: true,
            status: status,
            priority: priority,
            state: stateids,
            region: region,
            zone: zone,
            client: client,
            search: getthesearch,
            currentPage: currentPage,
            page_size: 20,
          },
        };
        

        dispatch(settheCreateInternalTickets(payload));
      }
    } else {
      toast.info("Please Fill the Mandatory Fields");
    }
  } finally {
    setCreating(false); // re-enable button
  }
};

    const capitalizeEachWord = (str) => {
        return str && typeof str === 'string'
            ? str
                .split(' ') // Split the string into an array of words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
                .join(' ') // Join the words back into a string
            : ''; // Return an empty string if the input is invalid
    };
    console.log(LoaderData ,"LoaderData");
    

    return (
        <>

            <div className="RoleCreatePopup" style={{ background: "#ffffffb5" }}>
                <div className="BeforePopUp">
                    <div className="RolePopups" style={{
                        width: "72%", borderRadius: "17px",
                        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}>
                        <div className="asd ticketRaisePopups">
                            {/* <div className="ModalHeader"> */}
                            {/* <div>
                                    <span>How can we help?</span>
                                </div> */}



                            {/* </div> */}
                            <div className='row ticketrasiseofViews'>
                                <div className='col-5 leftsidetParted'>
                                    <div className="Popupcreatetickets">
                                        <h3>How Can We Help?</h3>

                                        <div className="InnerImages">
                                            <img src={TicketCreation} alt="" />
                                        </div>
                                    </div>
                                    {state.SideBarFiles.Role ? (
                                        <div className="CreatedBy">
                                            <div className="CreateBodyofcontent">
                                                <div className="createrimgs">
                                                    <img src={Userim} alt="" />
                                                </div>
                                                <div className="CreatedByNames">
                                                    <p>
                                                        Created by{" "}
                                                        {capitalizeEachWord(state.SideBarFiles.Role)}{" "}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                                <div className='col-7 rightsideTicketCreated'>

                                    <div className='Closeofpopupse' >
                                        <img src={CloseIcons} alt="" onClick={(e) => {
                                            dispatch(settheTicketSuccesspopuos(false))
                                            // Navigate("/internalTicket");
                                            // state.NeededdatasListed.RoutesDefinedof == 0 ?Navigate("/internaldashboard") : Navigate("/internalTicket")

                                            if (state.NeededdatasListed.RoutesDefinedof == 0) {

                                                Navigate("/internaldashboard")
                                            }
                                            else {
                                                Navigate("/internalTicket")
                                            }
                                        }} />

                                    </div>

                                    <>
<div className="InnerClientticketingpopup">
                                       <div className="col-12 mb-3 d-flex">
                        <div className="col-6 mb-1 field-div">
                          <label for="validationCustom01" class="form-label">
                            State<span style={{ color: "red" }}>*</span>
                          </label>
                          <Select
                            value={StateVal}
                            options={StateOptions}
                            onChange={(e) => {
                              HandleTheStateChanges(e);
                            }}
                            onInputChange={(e) => {
                              HandletheStateSearch(e);
                            }}
                                  components={{ DropdownIndicator:  DropdownIndicator }}

                          />
                        </div>

                        <div className="col-6 mb-1 field-div">
                          <label for="validationCustom01" class="form-label">
                            Region<span style={{ color: "red" }}>*</span>
                          </label>
                          <Select
                            value={RegionVal}
                            options={RegionOption}
                            onChange={(e) => {
                              HandleTheRegionChanges(e);
                            }}
                            onInputChange={(e) => {
                              HandletheRegionSearch(e);
                            }}
                                  components={{ DropdownIndicator:  DropdownIndicator }}

                          />
                        </div>
                      </div>


                                       <div className="col-12 mb-3 d-flex">
                                                                <div className="col-6 mb-1 field-div">
                          <label for="validationCustom01" class="form-label">
                            Zone<span style={{ color: "red" }}>*</span>
                          </label>
                          <Select
                            value={ZoneValues}
                            options={ZoneOptions}
                            onChange={(e) => {
                              HandleTheZoneChanges(e);
                            }}
                            onInputChange={(e) => {
                              HandletheZoneSearch(e);
                            }}
                                  components={{ DropdownIndicator:  DropdownIndicator }}

                          />
                        </div>

                        <div className="col-6 mb-1 field-div">
                          <label for="validationCustom01" class="form-label">
                            Client
                          </label>
                          <Select
                            value={ClientValues}
                            options={ClientOptions}
                            onChange={(e) => {
                              HandletheclientValues(e);
                            }}
                            onInputChange={(e) => {
                              HandletheClientsSearch(e);
                            }}
                                  components={{ DropdownIndicator:  DropdownIndicator }}

                          />
                        </div>

           

                    
                      </div>



                                        <div className="col-12 mb-3 d-flex">

                                 <div className="col-6 mb-1 field-div">
                                                <label
                                                    for="validationCustom01"
                                                    class="form-label"
                                                >
                                                    Department
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <Select
                                                    value={departmentValue}
                                                    options={departmentoptions}

                                                    onChange={(e) => {
                                                        HandletheDepartmentvalues(e)
                                                    }}
                                                    onInputChange={(e) => { handleInputDepartment(e) }}
                                                          components={{ DropdownIndicator:  DropdownIndicator }}

                                                />

                                            </div>

                                            <div className="col-6 mb-1 field-div">
                                                <label
                                                    for="validationCustom01"
                                                    class="form-label"
                                                >
                                                    Category
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <Select
                                                    value={categoryvaluese}
                                                    options={categoryption}

                                                    onChange={(e) => {
                                                        HandletheCatgoryListed(e)
                                                    }}
                                                    onInputChange={(e) => { handleInputcategorySearc(e) }}
                                                          components={{ DropdownIndicator:  DropdownIndicator }}

                                                />

                                            </div>



                                        </div>

                                        <div className="col-12 mb-3 d-flex">

                                            <div className="col-6 mb-1 field-div">
                                                <label
                                                    for="validationCustom01"
                                                    class="form-label"
                                                >
                                                    Subcategory
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <Select
                                                    value={categoryvalue}
                                                    options={Categorydata}

                                                    onChange={(e) => {
                                                        HandleCategoryMuliti(e)
                                                    }}
                                                    onInputChange={(e) => { handleInputcategory(e) }}
                                                          components={{ DropdownIndicator:  DropdownIndicator }}

                                                />

                                            </div>

                                            <div className="col-6 mb-1 field-div">
                                                <label
                                                    for="validationCustom01"
                                                    class="form-label"
                                                >
                                                    Priority
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <Select
                                                    value={Priorityvalues}
                                                    options={priorityoptions}

                                                    onChange={(e) => {
                                                        handletheprioritychanges(e)
                                                    }}
                                                          components={{ DropdownIndicator:  DropdownIndicator }}

                                                />

                                            </div>

                                       

                                        </div>
<div className="col-12 mb-3 d-flex">
         <div className="col-6 mb-1 field-div">
                                                <label
                                                    for="validationCustom01"
                                                    class="form-label"
                                                >
                                                    User
                                                </label>
                                                <Select
                                                    value={User_selected}
                                                    options={User_options}
isClearable
                                                    onChange={(e) => {
                                                        handletheUser_selected(e)
                                                    }}
                                                          components={{ DropdownIndicator:  DropdownIndicator }}
                                                    onInputChange={(e) => { handleUser_serached(e) }}

                                                />

                                            </div>
</div>
                                        <div className="col-12 mb-3 d-flex">

                                            <div className="col-12 mb-1 field-div">
                                                <label
                                                    for="validationCustom01"
                                                    class="form-label"
                                                >
                                                    Description
                                                    {/* <span style={{ color: "red" }}>*</span> */}
                                                </label>
                                                <textarea className="form-control"

                                                    onChange={(e) => {
                                                        const inputValue = e.target.value;

                                                        setData({
                                                            ...data,
                                                            remarks:
                                                                inputValue.charAt(0).toUpperCase() +
                                                                inputValue.slice(1),
                                                        });
                                                    }}
                                                    value={data.remarks}

                                                />

                                            </div>

                                        </div>


                                        <div className="col-12 mb-5 DocumentsUpload">
                                            <div className="col-12 mb-1 field-div">
                                                <label className="form-label LabelRemove">
                                                    Attachments Upload
                                                </label>
                                                <div
                                                    className="form-control InnerControls"
                                                    onDrop={handleDrop}
                                                    onDragOver={handleDragOver}
                                                    onDragEnter={handleDragEnter}
                                                    onDragLeave={handleDragLeave}
                                                    style={{
                                                        borderRadius: "10px",
                                                        textAlign: "center",
                                                        backgroundColor: isDragging
                                                            ? "hsla(203, 49%, 81%, 0.25)"
                                                            : "transparent", // Change background color
                                                        transition: "background-color 0.3s ease", // Smooth transition
                                                    }}
                                                >
                                                    <div className="d-flex flex-wrap align-items-center gap-3" style={{ gap: "24px" }}>
                                                        {
                                                            PresentUrls.map((file, index) => {
                                                                let displayImg
                                                                //   if (
                                                                //     file.type === "image/png" ||
                                                                //     file.type === "image/jpeg"
                                                                //   ) {
                                                                //     displayImg = Attachment; // Replace with your gallery image variable
                                                                //   } else if (file.type === "application/pdf") {
                                                                //     displayImg = Attachment; // Replace with your PDF icon variable
                                                                //   } else if (
                                                                //     file.type === "application/vnd.ms-excel" ||
                                                                //     file.type ===
                                                                //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                                //   ) {
                                                                //     displayImg = Attachment; // Replace with your Excel icon variable
                                                                //   } else {
                                                                //     displayImg = Attachment; // Replace with a default image/icon if none match
                                                                //   }


                                                                if (file.type === "image/png" || file.type === "image/jpeg") {
                                                                    displayImg = galleyimg; // Replace with your gallery image variable
                                                                } else if (file.type === "application/pdf") {
                                                                    displayImg = PDFIMAGE; // Replace with your PDF icon variable
                                                                } else if (file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                                                                    displayImg = excelimg; // Replace with your Excel icon variable
                                                                } else {
                                                                    displayImg = gallimages; // Replace with a default image/icon if none match
                                                                }

                                                                return (
                                                                    <>
                                                                        <div
                                                                            key={index}
                                                                            style={{
                                                                                position: "relative",
                                                                                width: "38px",
                                                                                height: "38px",
                                                                                borderRadius: "8px",
                                                                            }}
                                                                        >

                                                                            <img
                                                                                src={displayImg}
                                                                                alt={`Uploaded File ${index + 1}`}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    objectFit: "cover",
                                                                                    borderRadius: "8px",
                                                                                    border: "1px solid #ddd",
                                                                                }}
                                                                            />
                                                                            <span
                                                                                style={{
                                                                                    fontSize: "12px",
                                                                                    textTransform: "capitalize",
                                                                                }}
                                                                            >
                                                                                {file?.putfiles?.name?.length > 5
                                                                                    ? `${file?.putfiles.name.slice(
                                                                                        0,
                                                                                        5
                                                                                    )}...`
                                                                                    : file?.putfiles?.name}
                                                                            </span>
                                                                            <button
                                                                                type="button"
                                                                                className=" btn-danger btn-sm DeleteImages"
                                                                                onClick={() => removeFile(index)}
                                                                            >
                                                                                &times;
                                                                            </button>
                                                                        </div>
                                                                    </>
                                                                );
                                                            })
                                                        }

                                                        {uploadedFiles.length == 0 && (
                                                            <div className="InnerImages InnerImgGallery d-flex flex-wrap align-items-center  justify-content-center">
                                                                <img src={galleryImg} 
                                                                style={{ cursor: "pointer", width: "120px" }}
        onClick={handleImageClick}
/>
                                                            </div>
                                                        )}
                                                    </div>
 
                                                    <p style={{flexDirection:"column"}}>
{Object.entries(progress).map(([filename, percent]) => (
  uploading[filename] == true ? (
    <Box
     key={filename} 
     sx={{ width: "100%", mb: 1 }}>
      <LinearProgress
        variant="determinate"
        value={percent}
        sx={{
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#f2683a",
            height:"2px"
          },
          backgroundColor: "#ffe2d7",
                      height:"2px"

        }}
      />
    </Box>
  ) : null
))}

                                                     <span>
                                                        Drag your files and here to Upload

                                                        <label
                                                            className="Droplabel Droplabel2"
                                                            htmlFor="fileUploadInput"
                                                        >
                                                            Browse file
                                                        </label>

                                                        <input
                                                            id="fileUploadInput"
                                                            type="file"
                                                                    ref={fileInputRef}
                                                            style={{ display: "none" }} // Hidden input
                                                            onChange={handleFileChange} // Handles file selection
                                                            multiple // Allows multiple file selection
                                                                accept=".jpg,.jpeg,.png,.pdf,.docx,.xlsx" // Restrict file types
                                                        />
                                                     
                                                     </span>
 

                                                    </p>
                                                    <span>
                                                         (You can upload JPG, PNG, PDF, DOCX, XLSX files — up to 25 MB each)
</span>

                                                </div>
                                            </div>
                                        </div>

                                        </div>

                                    </>

                                    <div className="RoleButton"
                                        style={{
                                            display: "flex",
                                            gap: "15px",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            padding: "0px  29px"
                                        }}

                                    >
                                        <button
                                            class="btn  Createbutton"
                                            type="submit"
                                            disabled={creating}
                                            onClick={(e) => {
                                                HandleClick(e);
                                            }}
                                        >
                                             Create Ticket
                                        </button>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {state.NeededdatasListed.TicketSucssesPopup && (
                <>
                    <div className="CommentPopup">
                        <div className="innercommentpopup">
                            <div className="FormPartsthanks FormPartsticketslist FormPartsticketsCreated">
                                <div className="innerformscomentpart">
                                    <div className="Notifyimgsthumbs">
                                        <img src={thumbsup} />
                                    </div>
                                    <div className="closecontent CloseIcons">
                                        <img
                                            src={closepopup}
                                            alt=""
                                            onClick={(e) => {
                                                setthankcontent(false);
                                                dispatch(settheTicketSuccesspopuos(false))
                                                // settheThankpopup(false);
                                                if (state.NeededdatasListed.RoutesDefinedof == 0) {

                                                    Navigate("/internaldashboard")
                                                }
                                                else {
                                                    Navigate("/internalTicket")
                                                }
                                                // Navigate("/internalTicket");
                                            }}
                                        />
                                    </div>

                                    <div className="ticketnumberlist">
                                        <span className="InnerNUmber">
                                            <img src={ticketimg} />
                                            <span>
                                                {"ID  "}
                                                {state.CreateinternalTicketListed.CreateInternalTicketListeds.ticket_number}
                                            </span>
                                        </span>
                                    </div>
                                    <h5 className="pt-4">Ticket Successfully Created!</h5>

                                    <div className="FeedbackFieldcraetes ">


                                        <p className="Ticketscreatedsuccessfully">

                                            Thank you for bringing this to our attention.
                                        </p>
                                    </div>
                                    <div className="feedbacksubmition">
                                        <button
                                            onClick={(e) => {
                                                setthankcontent(false);
                                                dispatch(settheTicketSuccesspopuos(false))
                                                dispatch(settheTicketViewIds(state.CreateinternalTicketListed.CreateInternalTicketListeds.id))

                                                // settheThankpopup(false);
                                                // settheTicketIDs(TicketCreateREsponse?.id);
                                                Navigate("/internalTicketView");
                                            }}
                                        >
                                            View Ticket
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}


        </>
    )
}

export default TicketraiseforInternal


